import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  fetchPermits,
} from '../api/govopsPermitService';
import { formatGovOpsError, isGovOpsAuthError } from '../api/govopsErrors';
import PageShell from './PageShell';

const PermitList = () => {
  const [permits, setPermits] = useState([]);
  const [blockedMsg, setBlockedMsg] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      setBlockedMsg('');
      try {
        setPermits(await fetchPermits());
      } catch (err) {
        if (!isGovOpsAuthError(err)) console.error(err);
        setBlockedMsg(formatGovOpsError(err));
        setPermits([]);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading) return <PageShell title="All permits"><p>Loading permits…</p></PageShell>;

  return (
    <PageShell title="All permits" subtitle="Permits from GovOps for your organization.">
      {blockedMsg && <p className="rhs-error" role="alert">{blockedMsg}</p>}
      {permits.length === 0 && !blockedMsg && <p className="rhs-muted">No permits found.</p>}
      <ul className="rhs-list">
        {permits.map((p) => (
          <li key={p.id}>
            <Link to={`/permit-details/${p.id}`}>
              {p.type || 'Permit'} — {p.description || p.id}
            </Link>
          </li>
        ))}
      </ul>
    </PageShell>
  );
};

export default PermitList;
